export default "__VITE_ASSET__5748ceb3__"